import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { CSSProperties, useState, useRef } from 'react';
import { Form, FormControlProps } from 'react-bootstrap';

export interface SearchBoxProps extends FormControlProps {
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  formClassName?: string;
  size?: 'sm' | 'lg';
  style?: CSSProperties;
}

const SearchBox = ({
  placeholder = 'Search',
  size,
  className,
  inputClassName,
  formClassName,
  style,
  ...rest
}: SearchBoxProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleOpen = () => {
    setIsExpanded(true);
    setTimeout(() => inputRef.current?.focus(), 100);
  };

  const handleClose = () => {
    setIsExpanded(false);
    if (inputRef.current) {
      inputRef.current.value = '';
      const event = new Event('input', { bubbles: true });
      inputRef.current.dispatchEvent(event);
    }
  };

  if (!isExpanded) {
    return (
      <button
        className={classNames('btn d-flex align-items-center gap-2', className)}
        style={{
          ...style,
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '0.375rem',
          padding: '0.375rem 0.75rem',
          fontSize: '0.875rem',
          color: '#374151',
          fontWeight: '400'
        }}
        onClick={handleOpen}
      >
        <FontAwesomeIcon icon={faSearch} style={{ fontSize: '0.875rem' }} />
        <span>Search</span>
      </button>
    );
  }

  return (
    <div
      className={classNames(
        'position-relative d-flex align-items-center',
        className
      )}
      style={{
        ...style,
        backgroundColor: 'white',
        border: '1px solid #e5e7eb',
        borderRadius: '0.375rem',
        padding: '0.375rem 0.75rem',
        width: '220px',
        transition: 'width 0.3s ease'
      }}
    >
      <FontAwesomeIcon
        icon={faSearch}
        style={{
          color: '#9ca3af',
          fontSize: '0.875rem',
          marginRight: '0.5rem'
        }}
      />
      <Form.Control
        ref={inputRef}
        type="search"
        placeholder={placeholder}
        className={classNames('border-0 p-0 shadow-none', inputClassName)}
        size={size}
        style={{
          fontSize: '0.875rem',
          outline: 'none',
          boxShadow: 'none'
        }}
        {...rest}
      />
      <FontAwesomeIcon
        icon={faTimes}
        style={{
          color: '#6b7280',
          fontSize: '0.875rem',
          cursor: 'pointer',
          marginLeft: '0.5rem'
        }}
        onClick={handleClose}
      />
    </div>
  );
};

export default SearchBox;
